import { render } from "./QuestionnaireResults.vue?vue&type=template&id=f3ec3f6a&scoped=true"
import script from "./QuestionnaireResults.vue?vue&type=script&lang=js"
export * from "./QuestionnaireResults.vue?vue&type=script&lang=js"

import "./QuestionnaireResults.vue?vue&type=style&index=0&id=f3ec3f6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3ec3f6a"]])

export default __exports__